module.exports = __webpack_public_path__ + "img/Slide18.7422cabb.png";